import { render, staticRenderFns } from "./LatestTransactions.vue?vue&type=template&id=19513010&scoped=true&"
import script from "./LatestTransactions.vue?vue&type=script&setup=true&lang=js&"
export * from "./LatestTransactions.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./LatestTransactions.vue?vue&type=style&index=0&id=19513010&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19513010",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VBtnToggle,VIcon,VSimpleTable})
